import {authConstants, commoncodeConstants, commonConstants, uriConstants} from '../constants'
import {commonService, defaultService} from '../services'
import { alertActions } from './'
import { errorMessages } from '../messages'

export const commonActions = {
  getZipAddress,
  getCommonCode,
  resetZipCode,
  close,
}

/*********
 주소 찾기
**********/

function getZipAddress(params) {
  return async dispatch => {
    dispatch(request())

    commonService.getZipAddress(params)
    .then(
      response => {
        dispatch(success(response))
      },
      error => {
        dispatch(failure(error))
        dispatch(alertActions.error({
          title: null,
          message: errorMessages.systemError
        }))
      }
    )
  }
  function request() {
    return {
      type: commonConstants.ZIP_LOAD_REQUEST
    }
  }
  function success(response) {
    return {
      type: commonConstants.ZIP_LOAD_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: commonConstants.ZIP_LOAD_FAILURE,
      response
    }
  }
}

/**
 * 우편번호 정보 초기화
 * @returns {{type: string}}
 */
function resetZipCode() {
  return { type: commonConstants.ZIP_LOAD_RESET }
}

/*********
 공통코드 조회
 **********/

function getCommonCode(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_COMMON_CODE + paramStr,
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(alertActions.error({
            title: null,
            message: errorMessages.systemError
          }))
        }
      )
  }
  function request() {
    return {
      type: commoncodeConstants.GETCOCLASS_REQUEST
    }
  }
  function success(response) {
    return {
      type: commoncodeConstants.GETCOCLASS_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: commoncodeConstants.GETCOCLASS_FAILURE,
      response
    }
  }
}

/***********
 컨트랙터 닫기
************/

function close() {
  return async dispatch => {
    dispatch(toggle())
  }
  function toggle() {
    return {
      type: commoncodeConstants.GETCOCLASS_CLOSE
    }
  }
}
